//User

export const LOGIN_USER = 'LOGIN_USER';
export const LOGOUT_USER = 'LOGOUT_USER';

//Global

export const QUERY_IS_LOADING = 'QUERY_IS_LOADING';
export const QUERY_NOT_LOADING = 'QUERY_NOT_LOADING';